"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const country_entity_1 = require("./country.entity");
const state_entity_1 = require("./state.entity");
const city_entity_1 = require("./city.entity");
const class_transformer_1 = require("class-transformer");
const contact_address_entity_1 = require("./contact-address.entity");
const tpa_address_entity_1 = require("./tpa-address.entity");
const insurer_address_entity_1 = require("./insurer-address.entity");
const company_address_entity_1 = require("./company.address.entity");
const look_up_entity_1 = require("./look-up.entity");
const broker_address_entity_1 = require("./broker-address.entity");
const opportunity_risk_locations_entity_1 = require("./opportunity-risk-locations.entity");
/**
 * Entity representing an address.
 */
let Address = class Address {
    constructor(addressTypeLid, address1, countryId, stateId, cityId, phoneNumber, address2, area, pinCode, alternatePhoneNumber, email, supportNumber, createdBy, updatedBy, createdAt, updatedAt, contactAddresses) {
        this.addressTypeLid = addressTypeLid;
        this.address1 = address1;
        this.countryId = countryId;
        this.stateId = stateId;
        this.cityId = cityId;
        this.address2 = address2 ?? "";
        this.area = area ?? "";
        this.pinCode = pinCode ?? "";
        this.phoneNumber = phoneNumber;
        this.alternatePhoneNumber = alternatePhoneNumber ?? "";
        this.email = email ?? "";
        this.supportNumber = supportNumber ?? "";
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.createdAt = createdAt ?? new Date();
        this.updatedAt = updatedAt ?? new Date();
        this.contactAddresses = contactAddresses;
    }
};
exports.Address = Address;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Object)
], Address.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "address_type_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Address.prototype, "addressTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "addr_1", type: "varchar", length: 200 }),
    tslib_1.__metadata("design:type", String)
], Address.prototype, "address1", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "addr_2", type: "varchar", length: 200, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Address.prototype, "address2", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "area", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Address.prototype, "area", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "pincode", type: "varchar", length: 20, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Address.prototype, "pinCode", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "phone_number", type: "varchar", length: 20 }),
    tslib_1.__metadata("design:type", String)
], Address.prototype, "phoneNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "alternate_phone_number",
        type: "varchar",
        length: 20,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], Address.prototype, "alternatePhoneNumber", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "email", type: "varchar", length: 100, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Address.prototype, "email", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "support_number",
        type: "varchar",
        length: 20,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], Address.prototype, "supportNumber", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], Address.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], Address.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Address.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Address.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_j = typeof Date !== "undefined" && Date) === "function" ? _j : Object)
], Address.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => country_entity_1.Country, (country) => country.id, { eager: true }),
    (0, typeorm_1.JoinColumn)({ name: "country_id" }) // Ensure the correct column name is used
    ,
    tslib_1.__metadata("design:type", typeof (_k = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _k : Object)
], Address.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => state_entity_1.State, (state) => state.id, { eager: true }),
    (0, typeorm_1.JoinColumn)({ name: "state_id" }) // Ensure the correct column name is used
    ,
    tslib_1.__metadata("design:type", typeof (_l = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _l : Object)
], Address.prototype, "stateId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => city_entity_1.City, (city) => city.id, { eager: true }),
    (0, typeorm_1.JoinColumn)({ name: "city_id" }) // Ensure the correct column name is used
    ,
    tslib_1.__metadata("design:type", typeof (_m = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _m : Object)
], Address.prototype, "cityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => contact_address_entity_1.ContactAddress, (contactAddress) => contactAddress.address, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", typeof (_o = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _o : Object)
], Address.prototype, "contactAddresses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => insurer_address_entity_1.InsurerAddress, (insurerAddress) => insurerAddress.address, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", typeof (_p = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _p : Object)
], Address.prototype, "insurerAddresses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => broker_address_entity_1.BrokerAddress, (BrokerAddress) => BrokerAddress.address, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", typeof (_q = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _q : Object)
], Address.prototype, "brokerAddresses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => company_address_entity_1.CompanyAddress, (companyAddress) => companyAddress.address, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", typeof (_r = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _r : Object)
], Address.prototype, "companyAddresses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => tpa_address_entity_1.TpaAddress, (tpaAddress) => tpaAddress.address, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", typeof (_s = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _s : Object)
], Address.prototype, "tpaAddresses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "address_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_t = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _t : Object)
], Address.prototype, "addressType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_risk_locations_entity_1.OpportunityRiskLocations, (opportunityRiskLocations) => opportunityRiskLocations.address, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", typeof (_u = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _u : Object)
], Address.prototype, "opportunityRiskLocations", void 0);
exports.Address = Address = tslib_1.__decorate([
    (0, typeorm_1.Entity)("address"),
    tslib_1.__metadata("design:paramtypes", [Number, String, typeof (_a = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _a : Object, typeof (_b = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _b : Object, typeof (_c = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _c : Object, String, String, String, String, String, String, String, Number, Number, typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object, typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object, typeof (_f = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _f : Object])
], Address);
